var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-view"},[_c('CheckableTreeViewItem',{ref:"treeView",attrs:{"collapsed":true,"data":_vm.data[0],"form-type":_vm.formType,"depth":0,"numbering":_vm.getNumbering(),"pretty-display":_vm.prettyDisplay}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3f529b6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/CheckableTreeView.vue
// module id = +H6d
// module chunks = 70